export const getWebpSrc = (src = '') => {
  if (typeof src !== 'string' || src.length === 0) {
    return '';
  }

  const suffixStart = src.search(/[?#]/);
  const pathname = suffixStart >= 0 ? src.slice(0, suffixStart) : src;
  const suffix = suffixStart >= 0 ? src.slice(suffixStart) : '';
  const webpPathname = pathname.replace(/\.(jpg|jpeg|png)$/i, '.webp');

  return `${webpPathname}${suffix}`;
};
